// Some publications ship XHTML spine items with mangled structure — notably
// the hub's generated samples, whose truncation tool strips the <head>
// element and leaves its children in <body> (WEB-READER-1640). A head-less
// document survives DOMParser (it is well-formed XML) but crashes the
// navigator's frame builder, which dereferences doc.head unconditionally.

const HEAD_TAG = /<head[\s/>]/i;
const BODY_TAG = /<body[\s/>]/i;
const HTML_OPEN_TAG = /<html(\s[^>]*)?>/i;

export type MarkupSanity = {
  doc: string;
  /** a missing <head> was inserted after the opening <html> tag */
  repairedHead: boolean;
  /** structural problems detected but left as-is */
  anomalies: string[];
};

export function checkMarkup(doc: string): MarkupSanity {
  const anomalies: string[] = [];
  let repairedHead = false;

  const htmlOpen = doc.match(HTML_OPEN_TAG);
  if (!htmlOpen) {
    anomalies.push("missing <html>");
  }
  if (!BODY_TAG.test(doc)) {
    anomalies.push("missing <body>");
  }
  if (!HEAD_TAG.test(doc)) {
    if (htmlOpen) {
      const at = (htmlOpen.index ?? 0) + htmlOpen[0].length;
      doc = doc.slice(0, at) + "<head></head>" + doc.slice(at);
      repairedHead = true;
    } else {
      // nowhere sensible to put one
      anomalies.push("missing <head>");
    }
  }

  return { doc, repairedHead, anomalies };
}
